module.exports = __webpack_public_path__ + "static/media/edit-icon.c5da092f.svg";